"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsServiceRpcAction = void 0;
var AnalyticsServiceRpcAction;
(function (AnalyticsServiceRpcAction) {
    AnalyticsServiceRpcAction["CheckIsWebhookAuthConfigUsedInReportScheduledJobs"] = "analytics-service:report-scheduled-jobs:check-is-webhook-auth-config-used";
    AnalyticsServiceRpcAction["GetScheduledJobsCountByWebhookAuthConfigIds"] = "analytics-service:scheduled-jobs:get-count-by-webhook-auth-config-ids";
})(AnalyticsServiceRpcAction || (exports.AnalyticsServiceRpcAction = AnalyticsServiceRpcAction = {}));
//# sourceMappingURL=rpc.js.map